<template>
    <v-app>
        <v-main>
            <v-container fill-height>
                <v-row justify="center" align="center">
                    <v-col class="text-center">
                        <div class="d-felx flex-column">
                            <v-icon size="70" color="secondary">mdi-lock</v-icon>
                            <h4 class="text-h4">Unauthorized</h4>
                            <p class="text-subtitle-1">You are not authorized to access this page. Please contact system administration.</p>
                            <v-btn class="primary" @click="$router.back()">go back</v-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
export default {

}
</script>

<style>

</style>